import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  static values = { open: { type: Boolean, default: false }, surface: String }

  // A destructive replacement reconnects this controller; a morph retains it and
  // updates the value instead. Stimulus invokes the callback for both lifecycles.
  openValueChanged(open) {
    if (open) this.open()
    else this.close()
  }

  open() {
    if (!this.hasDialogTarget || this.dialogTarget.open) return

    this.dialogTarget.showModal()
  }

  close() {
    if (!this.hasDialogTarget || !this.dialogTarget.open) return

    this.dialogTarget.close()
  }

  preserveOpen(event) {
    if (!this.hasDialogTarget || event.target !== this.dialogTarget) return
    if (event.detail.attributeName !== "open" || event.detail.mutationType !== "remove") return

    if (this.dialogTarget.open) event.preventDefault()
  }

  backdropClose(event) {
    if (!this.hasDialogTarget) return
    if (this.hasSurfaceValue) {
      const dismiss = this.backdropStarted && !event.target.closest(this.surfaceValue)
      this.backdropStarted = false
      if (dismiss) {
        event.preventDefault()
        event.stopPropagation()
        this.close()
      }
      return
    }
    if (event.target !== this.dialogTarget) return

    this.close()
  }

  backdropStart(event) {
    if (this.hasSurfaceValue) this.backdropStarted = event.isPrimary && !event.target.closest(this.surfaceValue)
  }

  backdropCancel() { this.backdropStarted = false }
}
